import { commonConstants } from '../_constants';
export function rateCharges(state = {}, action) {
  switch (action.type) {
    case commonConstants.GET_RATE_CHARGE_REQUEST:
      return {
        ...state,
        ratecharges: false,
        data: action.ratecharges.data,
      };
    case commonConstants.GET_RATE_CHARGE_SUCCESS:
      return {
        ...state,
        ratecharges: true,
        data: action.ratecharges.data.response,
      };
    case commonConstants.CLEAR_RATE:
      return {
        ...state,
        ratecharges: true,
        data: action.payload,
      };
    case commonConstants.GET_RATE_CHARGE_FAILURE:
      return {
        ...state,
        ratecharges: false,
        data: action.ratecharges.data,
      };
    default:
      return state;
  }
}

export function currencyCalc(state = {}, action) {
  switch (action.type) {
    case commonConstants.CURRENCTY_CAL_REQUEST:
      return {
        ...state,
        currencyCalc: true,
        data: action.currencyCalc.data,
      };
    case commonConstants.CURRENCTY_CAL_SUCCESS:
      return {
        ...state,
        currencyCalc: true,
        data: action.currencyCalc.data.response,
      };
    case commonConstants.CURRENCTY_CAL_FAILURE:
      return {
        ...state,
        currencyCalc: false,
        data: action.currencyCalc.data,
      };
    case commonConstants.CLEAR_CALC_CURR:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}

export function getRate(state = {}, action) {
  switch (action.type) {
    case commonConstants.RATES_REQUEST:
      return {
        ...state,
        getrates: false,
        data: action.rates.data,
      };
    case commonConstants.RATES_SUCCESS:
      return {
        ...state,
        getrates: true,
        data: action.rates.data.response,
      };
    case commonConstants.RATES_FAILURE:
      return {
        ...state,
        getrates: false,
        data: action.rates.data,
      };
    default:
      return state;
  }
}

export function currency(state = {}, action) {
  switch (action.type) {
    case commonConstants.CURRENCY_REQUEST:
      return {
        ...state,
        currency: true,
        data: action.currency,
      };
    case commonConstants.CURRENCY_SUCCESS:
      return {
        ...state,
        currency: true,
        data: action.currency.data.response,
      };
    case commonConstants.CURRENCY_FAILURE:
      return {
        ...state,
        currency: false,
        data: action.currency.data,
      };
    default:
      return state;
  }
}
